export const viewportOnce = { once: true, margin: '-80px', amount: 0.1 };

export const viewportSection = { once: true, margin: '-100px' };

export const viewportHeroItems = { once: true, margin: '0px' };